import { FeatureFlags } from '~src/ts/FeatureFlags';
import { PublishedConnectionContentType } from '~src/ts/models/ContentTypes';

import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IRevisionHistoryAction } from '../../../../ts/ServerApi/types/actionNames';
import { launchRevisionHistory } from '../../../actions/spaces/RevisionHistoryAction';
import { SessionSiteSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const RevisionHistoryEntityAction: IEntityAction<IContentInfo, IRevisionHistoryAction> = {
  name: EntityActionNames.RevisionHistory,
  translateName: Messages.revisionHistory_action,
  isVisible: (targetItems: IContentInfo[], appState: AppState) => {
    return SessionSiteSelectors.isVersioningEnabled(appState) && !isSingleEmbeddedDatasource(targetItems) && (targetItems[0].contentType === PublishedConnectionContentType.name ? FeatureFlags.vconnRevisionHistoryEnabled : true);
  },
  isClickable: (availableActions: IRevisionHistoryAction) => availableActions && availableActions.versionManagement,
  createReduxAction: (targetItems: IContentInfo[]) => launchRevisionHistory(targetItems[0])
};
